import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Bar } from 'react-chartjs-2';
import Box from '../components/Box';
import { fetchArqueos } from '../actions/arqueos';
import { fetchCustomers } from '../actions/customers';
import LoadingProgress from '../components/LoadingProgress';

class ArqueosGraphCompareView extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date().toISOString().slice(0, 10);

    this.state = {
      selectedDate: today,
      selectedCustomer: '',
      selectedDates: [],
      arqueosByDate: {},
    };
  }

  componentDidMount() {
    this.props.fetchCustomers();
  }

  handleFormChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSearch = async () => {
    const { selectedDate, selectedCustomer } = this.state;
    const { today, yesterday, lastYear } = this.getDateStrings(selectedDate);

    const selectedDates = [today, yesterday, lastYear];

    const [arqueosToday, arqueosYesterday, arqueosLastYear] = await Promise.all([
      this.props.fetchArqueos('', selectedCustomer, today, today, '') || [],
      this.props.fetchArqueos('', selectedCustomer, yesterday, yesterday, '') || [],
      this.props.fetchArqueos('', selectedCustomer, lastYear, lastYear, '') || [],
    ]);

    const arqueosByDate = {
      [today]: arqueosToday.response || [],
      [yesterday]: arqueosYesterday.response || [],
      [lastYear]: arqueosLastYear.response || [],
    };

    this.setState({
      selectedDates,
      arqueosByDate,
    });
  };

  getDateStrings(baseDateStr) {
    const baseDate = new Date(baseDateStr);
    const yesterday = new Date(baseDate);
    yesterday.setDate(baseDate.getDate() - 1);

    const lastYear = new Date(yesterday);
    lastYear.setFullYear(baseDate.getFullYear() - 1);

    const format = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

    return {
      today: format(baseDate),
      yesterday: format(yesterday),
      lastYear: format(lastYear),
    };
  }

  groupData() {
    const { arqueosByDate } = this.state;
    const grouped = {};

    Object.entries(arqueosByDate).forEach(([date, arqueos]) => {
      grouped[date] = {};
      (arqueos || []).forEach((a) => {
        const key = a.Customer?.Fullname?.trim() || 'Sin cliente';
        const amount = Number(a.SalesTotal || 0);
        grouped[date][key] = (grouped[date][key] || 0) + amount;
      });
    });

    return grouped;
  }

  renderBarChart(title) {
    const dataByDate = this.groupData();
    let labels = this.props.customers
      .filter((c) => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO')
      .map((c) => c.Fullname?.trim())
      .filter(Boolean);

    labels = Array.from(new Set(labels)).sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );

    if (labels.length === 0) {
      return (
        <Box title={title}>
          <p>No hay datos para mostrar.</p>
        </Box>
      );
    }

    const datasets = Object.entries(dataByDate).map(([date, data], i) => ({
      label: date,
      data: labels.map((label) => data[label] || 0),
      backgroundColor: `rgba(${50 + i * 60}, 99, 132, 0.5)`,
      borderColor: `rgba(${50 + i * 60}, 99, 132, 1)`,
      borderWidth: 1,
    }));

    const chartData = {
      labels,
      datasets,
    };

    return (
      <Box title={title}>
        <div style={{ height: '800px' }}>
          <Bar
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { position: 'top' },
                tooltip: { mode: 'index', intersect: false },
              },
              scales: {
                x: {
                  ticks: {
                    autoSkip: false,
                    maxRotation: 60,
                    minRotation: 45,
                    callback: function (val) {
                      const label = this.getLabelForValue(val);
                      return label.length > 20 ? label.slice(0, 20) + '…' : label;
                    },
                  },
                },
                y: {
                  beginAtZero: true,
                },
              },
            }}
          />
        </div>
      </Box>
    );
  }

  renderForm() {
    const customers = this.props.customers || [];

    return (
      <Box title="Filtro de Comparación" icon="filter">
        <form className="row" onSubmit={(e) => e.preventDefault()}>
          <div className="col">
            <label>Fecha</label>
            <input
              type="date"
              name="selectedDate"
              className="form-control"
              value={this.state.selectedDate}
              onChange={this.handleFormChange}
            />
          </div>
          <div className="col">
            <label>Cliente</label>
            <select
              name="selectedCustomer"
              className="form-control"
              value={this.state.selectedCustomer}
              onChange={this.handleFormChange}
            >
              <option value="">Todos</option>
              {customers
                .filter((c) => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO')
                .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                .map((c) => (
                  <option value={c._id} key={c._id}>
                    {c.Fullname}
                  </option>
                ))}
            </select>
          </div>
          <div className="col d-flex align-items-end">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleSearch}
            >
              Buscar
            </button>
          </div>
        </form>
      </Box>
    );
  }

  render() {
    const hasData = Object.keys(this.state.arqueosByDate).length > 0;

    return (
      <div>
        <h1 className="text-vw-dark">Comparativa de Ventas por Día</h1>
        {this.renderForm()}
        {hasData ? this.renderBarChart('Comparativa por Cliente') : <LoadingProgress />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customers: state.customers.customers,
  arqueos: state.arqueos.arqueos,
});

const mapDispatchToProps = (dispatch) => ({
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosGraphCompareView);
